"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tag = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _LocaleContext = require("@active/react-utils/i18n/LocaleContext");
var _withOnKeyboardConfirm = _interopRequireDefault(require("@active/react-utils/eventHandler/withOnKeyboardConfirm"));
var _excluded = ["children", "className", "deletable", "i18n", "color", "size", "disabled"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var COLORSTYLEMAP = {
  green: 'bg-natural-80 text-grey-100',
  greenLight: 'bg-natural-35 text-natural-100',
  red: 'bg-attention-100',
  redLight: 'bg-attention-55 text-attention-110',
  orange: 'bg-brand-100 text-brand-140',
  orangeLight: 'bg-brand-55 text-brand-120',
  blue: 'bg-primary-100',
  blueLight: 'bg-primary-50 text-primary-105',
  purple: 'bg-violet-70',
  magent: 'bg-magenta-100',
  cyan: 'bg-cyan-100 text-grey-100',
  yellow: 'bg-yellow-100 text-grey-100',
  light: 'bg-secondary-50 text-secondary-100',
  dark: '',
  grey: 'bg-grey-40 text-grey-100',
  white: 'tag-bordered bg-white-100 text-grey-100'
};
var DEFAULT_SIZE = 'md';
var Tag = exports.Tag = /*#__PURE__*/function (_React$Component) {
  function Tag(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Tag);
    _this = _callSuper(this, Tag, [props]);
    (0, _defineProperty2["default"])(_this, "handleDelete", function (e) {
      var _this$props = _this.props,
        value = _this$props.value,
        onDelete = _this$props.onDelete;
      onDelete === null || onDelete === void 0 || onDelete(value);
      e === null || e === void 0 || e.preventDefault();
      e === null || e === void 0 || e.stopPropagation();
    });
    (0, _defineProperty2["default"])(_this, "handleNativeClick", function (e) {
      _this.handleDelete();
      e.preventDefault();
      e.stopPropagation();
    });
    (0, _defineProperty2["default"])(_this, "handleNativeKeyDown", function (e) {
      (0, _withOnKeyboardConfirm["default"])(_this.handleDelete)(e);
    });
    (0, _defineProperty2["default"])(_this, "onDeleteIconOnKeyDown", (0, _withOnKeyboardConfirm["default"])(_this.handleDelete));
    _this.closeIconRef = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }
  (0, _inherits2["default"])(Tag, _React$Component);
  return (0, _createClass2["default"])(Tag, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$closeIconRef, _this$closeIconRef2;
      (_this$closeIconRef = this.closeIconRef) === null || _this$closeIconRef === void 0 || (_this$closeIconRef = _this$closeIconRef.current) === null || _this$closeIconRef === void 0 || _this$closeIconRef.addEventListener('click', this.handleNativeClick);
      (_this$closeIconRef2 = this.closeIconRef) === null || _this$closeIconRef2 === void 0 || (_this$closeIconRef2 = _this$closeIconRef2.current) === null || _this$closeIconRef2 === void 0 || _this$closeIconRef2.addEventListener('keydown', this.handleNativeKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$closeIconRef3, _this$closeIconRef4;
      (_this$closeIconRef3 = this.closeIconRef) === null || _this$closeIconRef3 === void 0 || (_this$closeIconRef3 = _this$closeIconRef3.current) === null || _this$closeIconRef3 === void 0 || _this$closeIconRef3.removeEventListener('click', this.handleNativeClick);
      (_this$closeIconRef4 = this.closeIconRef) === null || _this$closeIconRef4 === void 0 || (_this$closeIconRef4 = _this$closeIconRef4.current) === null || _this$closeIconRef4 === void 0 || _this$closeIconRef4.removeEventListener('keydown', this.handleNativeKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        deletable = _this$props2.deletable,
        i18n = _this$props2.i18n,
        color = _this$props2.color,
        _this$props2$size = _this$props2.size,
        size = _this$props2$size === void 0 ? DEFAULT_SIZE : _this$props2$size,
        disabled = _this$props2.disabled,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var dismissible = deletable && !disabled;
      var classes = (0, _classnames["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
        tag: true
      }, "tag-".concat(size), size && size !== DEFAULT_SIZE), "disabled", disabled), color && COLORSTYLEMAP[color], className);
      var closeBtnClasses = (0, _classnames["default"])({
        'tag-icon': true,
        'ic-cross': size === 'xs' || size === 'sm',
        'ic-cross-bold': size === DEFAULT_SIZE || size === 'lg'
      });
      var tagContentAccessbilityProps = dismissible ? {} : {
        role: 'button',
        tabIndex: 0
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes
      }, /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, tagContentAccessbilityProps, (0, _omit["default"])(['onDelete', 'value'])(props), {
        className: "tag-text"
      }), children), dismissible && /*#__PURE__*/_react["default"].createElement("i", {
        ref: this.closeIconRef,
        "data-nobubble": true,
        className: closeBtnClasses,
        role: "button",
        "aria-label": "".concat(i18n('react-ui.remove'), " ").concat(children),
        onClick: this.handleDelete,
        onKeyDown: this.onDeleteIconOnKeyDown,
        tabIndex: 0
      }));
    }
  }]);
}(_react["default"].Component);
(0, _defineProperty2["default"])(Tag, "defaultProps", {
  onDelete: _noop["default"]
});
var TagI18n = (0, _LocaleContext.withI18n)(Tag);
var _default = exports["default"] = TagI18n;